// Stinky — small interactions (nav drawer, accordion, variant picker)

(() => {
  const d = document;

  // Mobile nav toggle
  d.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-stinky-nav-toggle]');
    if (!btn) return;
    const nav = d.querySelector('[data-stinky-nav]');
    const open = nav.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
    d.body.style.overflow = open ? 'hidden' : '';
  });

  d.addEventListener('click', (e) => {
    const link = e.target.closest('[data-stinky-nav] a');
    if (!link) return;
    d.querySelector('[data-stinky-nav]')?.classList.remove('is-open');
    d.body.style.overflow = '';
  });

  // Accordion (FAQ)
  d.addEventListener('click', (e) => {
    const trigger = e.target.closest('.stinky-accordion__trigger');
    if (!trigger) return;
    const item = trigger.closest('.stinky-accordion__item');
    const open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open);
  });

  // Scent variant picker (PDP)
  d.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-scent-chip]');
    if (!chip) return;
    const picker = chip.closest('[data-scent-picker]');
    if (!picker) return;
    picker.querySelectorAll('[data-scent-chip]').forEach(c => c.classList.remove('is-active'));
    chip.classList.add('is-active');
    const variantId = chip.dataset.variantId;
    const input = picker.querySelector('input[name="id"]');
    if (input) input.value = variantId;
    const title = picker.querySelector('[data-scent-active-name]');
    if (title) title.textContent = chip.dataset.scentName;
    const price = picker.querySelector('[data-scent-active-price]');
    if (price && chip.dataset.scentPrice) price.textContent = chip.dataset.scentPrice;
    const media = picker.querySelector('[data-scent-active-media]');
    if (media && chip.dataset.scentImage) {
      media.src = chip.dataset.scentImage;
      media.alt = chip.dataset.scentName;
    }
  });

  // Quantity stepper
  d.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const step = parseInt(btn.dataset.qtyStep, 10);
    const input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Reveal on scroll
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    d.querySelectorAll('[data-stinky-reveal]').forEach(el => io.observe(el));
  } else {
    d.querySelectorAll('[data-stinky-reveal]').forEach(el => el.classList.add('is-in'));
  }
})();
